/* tslint:disable */
/* eslint-disable */
/**
 * Bank Accounts API
 * API for managing bank accounts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BankAccountDto
 */
export interface BankAccountDto {
    /**
     * Unique identifier of the bank account
     * @type {string}
     * @memberof BankAccountDto
     */
    id: string;
    /**
     * Unique identifier of the person who owns the account
     * @type {string}
     * @memberof BankAccountDto
     */
    personId: string;
    /**
     * International Bank Account Number
     * @type {string}
     * @memberof BankAccountDto
     */
    iban: string;
    /**
     * Bank Identifier Code (BIC/SWIFT)
     * @type {string}
     * @memberof BankAccountDto
     */
    bic?: string | null;
    /**
     * Label or name of the bank account
     * @type {string}
     * @memberof BankAccountDto
     */
    label: string;
    /**
     * Indicates if this is the default bank account for the person
     * @type {boolean}
     * @memberof BankAccountDto
     */
    isDefault: boolean;
    /**
     * Indicates if this bank account is currently selected
     * @type {boolean}
     * @memberof BankAccountDto
     */
    isSelected: boolean;
    /**
     * ID of the stored RIB file (null if no RIB attached)
     * @type {string}
     * @memberof BankAccountDto
     */
    storedFileId?: string | null;
    /**
     * Date and time when the bank account was created
     * @type {Date}
     * @memberof BankAccountDto
     */
    creationTime: Date;
}

/**
 * Check if a given object implements the BankAccountDto interface.
 */
export function instanceOfBankAccountDto(value: object): value is BankAccountDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('personId' in value) || value['personId'] === undefined) return false;
    if (!('iban' in value) || value['iban'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('isDefault' in value) || value['isDefault'] === undefined) return false;
    if (!('isSelected' in value) || value['isSelected'] === undefined) return false;
    if (!('creationTime' in value) || value['creationTime'] === undefined) return false;
    return true;
}

export function BankAccountDtoFromJSON(json: any): BankAccountDto {
    return BankAccountDtoFromJSONTyped(json, false);
}

export function BankAccountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BankAccountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'personId': json['personId'],
        'iban': json['iban'],
        'bic': json['bic'] == null ? undefined : json['bic'],
        'label': json['label'],
        'isDefault': json['isDefault'],
        'isSelected': json['isSelected'],
        'storedFileId': json['storedFileId'] == null ? undefined : json['storedFileId'],
        'creationTime': (new Date(json['creationTime'])),
    };
}

export function BankAccountDtoToJSON(json: any): BankAccountDto {
    return BankAccountDtoToJSONTyped(json, false);
}

export function BankAccountDtoToJSONTyped(value?: BankAccountDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'personId': value['personId'],
        'iban': value['iban'],
        'bic': value['bic'],
        'label': value['label'],
        'isDefault': value['isDefault'],
        'isSelected': value['isSelected'],
        'storedFileId': value['storedFileId'],
        'creationTime': ((value['creationTime']).toISOString()),
    };
}

